import _WidgetBaseSP from 'more/_WidgetBaseSP';
import lang from 'dojo/_base/lang';
import { compose, mdsWidget, mdsLazyProto } from 'dojo/_base/declare';
import template from './PersonalDocumentInfoDataForm.html?raw';
import on from 'dojo/on';
import CollapsibleSection from '../CollapsibleSection/CollapsibleSection';
import Edit from '../../../moreCore/UI/Edit/Edit';
import '../../../moreCore/UI/Edit/Edit';
import SelectBox from '../../../moreCore/UI/SelectBox/SelectBox';
import '../../../moreCore/UI/SelectBox/SelectBox';
import DateInput from '../../../moreCore/UI/DateInput/DateInput';
import '../../../moreCore/UI/DateInput/DateInput';
import Button from '../../../moreCore/UI/Button/Button';
import '../../../moreCore/UI/Button/Button';
import domConstruct from 'dojo/dom-construct';
import CheckBox from '../../../moreCore/UI/CheckBox/CheckBox';
import GenericDialog from '../../../moreCore/UI/GenericDialog/GenericDialog';
import SearchSelect from '../../../moreCore/UI/SearchSelect/SearchSelect';

class PersonalDocumentInfoDataForm extends compose(_WidgetBaseSP) {
    templateString: any = template;
    isReadonly: boolean = false;
    isDirty: boolean = false;

    newDocumentContainer: HTMLElement;
    selectedDocumentInfoContainer: HTMLElement;
    documentSelect: MdsLax<InstanceType<typeof SelectBox>>;
    allDocuments: Array<IndividualData_PersonalDocumentInfo>;
    btn_setAsInactive: HTMLElement;

    readonlyDocumentIsActive: HTMLInputElement;
    readonlyDocumentNumber: HTMLInputElement;
    readonlyDocumentValidFrom: HTMLInputElement;
    readonlyDocumentValidUntil: HTMLInputElement;
    readonlyDocumentIssuedAuthority: HTMLInputElement;

    newDocumentType: MdsLax<InstanceType<typeof SelectBox>>;
    newDocumentNumber: MdsLax<InstanceType<typeof Edit>>;
    newDocumentValidFrom: MdsLax<InstanceType<typeof DateInput>>;
    newDocumentValidUntil: MdsLax<InstanceType<typeof DateInput>>;
    newDocumentIssuedAuthority: MdsLax<InstanceType<typeof Edit>>;
    newDocumentIssuedCountry: MdsLax<InstanceType<typeof SearchSelect>>;
    newDocumentIsMainDocument: MdsLax<InstanceType<typeof CheckBox>>;
    saveNewDocumentBtn: MdsLax<InstanceType<typeof Button>>;
    newDocumentErrorContainer: HTMLElement;
    newDocumentErrorMessage: HTMLElement;


    formData: IndividualData_PersonalDocumentSave = {
        document_type: "",
        personal_doc_number: "",
        issued_country: "",
        issued_authority_original: "",
        date_valid_from: null,
        date_valid_until: null,
        is_main_document: false
    };
    originalData: string = "";

    loadFormData(data: Array<IndividualData_PersonalDocumentInfo>): void {

        this.allDocuments = data;

        this.allDocuments.length > 0 ? this.documentSelect.setPlaceholder(this.translations["FormLabel_AllDocuments_Placeholder"]) : this.documentSelect.setPlaceholder(this.translations["FormLabel_AllDocuments_Placeholder_empty"]);

        this.documentSelect.clear();

        data.forEach(doc => {
            let typeLabel: string;
            let active: string;
            switch (doc.Classname) {
                case "identity_card":
                    typeLabel = this.translations["FormDialog_Document_label_identityCard"];
                    break;
                case "passport":
                    typeLabel = this.translations["FormDialog_Document_label_passport"];
                    break;
                default:
            }

            let optionLabel = `${typeLabel.toUpperCase()}: ${doc.personal_doc_number} - ${doc.date_valid_until}`;
            if (doc.is_active === false) optionLabel = `${optionLabel} (INACTIV)`;

            this.documentSelect.addOption(doc.ID, optionLabel);
        });

        this.documentSelect.constructOptions();
        if (this.documentSelect.entries.length > 0) this.documentSelect.setValue(this.documentSelect.entries[0].value);

        this.constructDocumentInfo(this.documentSelect.getValue());

        this.createNewDocumentSection();
    }

    createNewDocumentSection(): void {

        this.UiModder.domConstruct.empty(this.newDocumentContainer);

        let cs = new CollapsibleSection();
        cs.sectionName = "new_personal_document_section";
        cs.isEditable = false;
        cs.collapsibleHeading.innerHTML = this.translations["FormLabel_Collapsible_NewDocument"];
        cs.placeAt(this.newDocumentContainer);

        this.UiModder.domConstruct.empty(cs.collapsibleContainer);

        //Document type
        let div = domConstruct.create("div", { class: "w3-container w3-padding" }, cs.collapsibleContainer);

        //let RadioEntries: Array<{ value: string; label: string;}> = [];
        //RadioEntries.push({ value: "identity_card", label: "identity_card" });
        //RadioEntries.push({ value: "passport", label: "Passport" });

        this.newDocumentType = new SelectBox();
        this.newDocumentType.setMandatory(true);
        this.newDocumentType.setLabel(this.translations["FormDialog_Document_type"]);
        this.newDocumentType.addOption("identity_card", this.translations["FormDialog_Document_label_identityCard"]);
        this.newDocumentType.addOption("passport", this.translations["FormDialog_Document_label_passport"]);
        this.newDocumentType.constructOptions();
        this.newDocumentType.setValue("identity_card");

        this.UiModder.domClass.add(this.newDocumentType.domNode, "w3-quarter");
        this.UiModder.domClass.remove(this.newDocumentType.domNode, "selectbox");
        this.newDocumentType.placeAt(div);
        on(this.newDocumentType, "change", lang.hitch(this, this._onChange_newDocumentData));


        //County
        div = domConstruct.create("div", { class: "w3-container w3-padding" }, cs.collapsibleContainer);
        this.newDocumentIssuedCountry = new SearchSelect();

        this.newDocumentIssuedCountry.setLabel(this.translations["FormLabel_IssuedCountry"]);
        this.newDocumentIssuedCountry.labelAttribute = "description";
        this.newDocumentIssuedCountry.setPlaceholder(this.translations["FormLabel_IssuedCountry_Placeholder"]);
        this.newDocumentIssuedCountry.setDropDownPositionAbsolute(false);
        this.newDocumentIssuedCountry.setUrl("IndividualDataSheet/GetNationalitiesValues");
        this.UiModder.domClass.add(this.newDocumentIssuedCountry.domNode, "w3-quarter");
        this.newDocumentIssuedCountry.placeAt(div);
        this.newDocumentIssuedCountry.loadListValues();
        on(this.newDocumentIssuedCountry, "change", lang.hitch(this, this._onChange_newDocumentData));

        //Document Number
        div = domConstruct.create("div", { class: "w3-container w3-padding" }, cs.collapsibleContainer);
        this.newDocumentNumber = new Edit();

        this.newDocumentNumber.setLabel(this.translations["FormLabel_DocumentNumber"]);
        this.newDocumentNumber.setMandatory(true);
        this.UiModder.domClass.add(this.newDocumentNumber.domNode, "w3-quarter");
        this.newDocumentNumber.placeAt(div);
        on(this.newDocumentNumber, "change", lang.hitch(this, this._onChange_newDocumentData));

        //Issued Authority
        div = domConstruct.create("div", { class: "w3-container w3-padding" }, cs.collapsibleContainer);
        this.newDocumentIssuedAuthority = new Edit();

        this.newDocumentIssuedAuthority.setLabel(this.translations["FormLabel_IssuedAuthority"]);
        this.newDocumentIssuedAuthority.setMandatory(true);
        this.UiModder.domClass.add(this.newDocumentIssuedAuthority.domNode, "w3-quarter");
        this.newDocumentIssuedAuthority.placeAt(div);
        on(this.newDocumentIssuedAuthority, "change", lang.hitch(this, this._onChange_newDocumentData));

        //Document Valid Dates
        div = domConstruct.create("div", { class: "w3-container w3-padding" }, cs.collapsibleContainer);
        this.newDocumentValidFrom = new DateInput();
        this.newDocumentValidUntil = new DateInput();

        this.newDocumentValidFrom.setLabel(this.translations["FormLabel_DateValidFrom"]);
        this.newDocumentValidFrom.setMaxValue(new Date);
        this.newDocumentValidFrom.setMandatory(true);
        this.UiModder.domClass.add(this.newDocumentValidFrom.domNode, "w3-quarter w3-margin-right");
        this.newDocumentValidFrom.placeAt(div);
        on(this.newDocumentValidFrom, "change", lang.hitch(this, this._onChange_newDocumentData));

        this.newDocumentValidUntil.setLabel(this.translations["FormLabel_DateValidUntil"]);
        this.newDocumentValidUntil.setMinValue(new Date);
        this.newDocumentValidUntil.setMandatory(true);
        this.UiModder.domClass.add(this.newDocumentValidUntil.domNode, "w3-quarter");
        this.newDocumentValidUntil.placeAt(div);
        on(this.newDocumentValidUntil, "change", lang.hitch(this, this._onChange_newDocumentData));

        //Main document checkbox
        div = domConstruct.create("div", { class: "w3-container w3-padding" }, cs.collapsibleContainer);
        this.newDocumentIsMainDocument = new CheckBox();

        this.newDocumentIsMainDocument.setLabel(this.translations["FormLabel_MainDocument"]);
        this.UiModder.domClass.add(this.newDocumentIsMainDocument.domNode, "w3-quarter");
        this.newDocumentIsMainDocument.placeAt(div);
        on(this.newDocumentIsMainDocument, "change", lang.hitch(this, this._onChange_newDocumentData));

        //Save Btn
        div = domConstruct.create("div", { class: "w3-container w3-padding" }, cs.collapsibleContainer);
        this.saveNewDocumentBtn = new Button();

        this.saveNewDocumentBtn.setLabel(this.translations["General_Save"]);
        this.saveNewDocumentBtn.setClasses("mds-button-base w3-padding w3-disabled round mds-hover-bright accentBG", " ");
        this.saveNewDocumentBtn.setIconLeft("fas fa-save");
        this.saveNewDocumentBtn.on("click", lang.hitch(this, this._onClick_saveBtn));
        this.saveNewDocumentBtn.placeAt(div);

        //Error container
        this.newDocumentErrorContainer = domConstruct.create("div", {
            class: "w3-container w3-padding w3-round w3-pale-red w3-text-red w3-hide flex_row_center w3-margin",
            style: "flex-wrap:nowrap"
        }, cs.collapsibleContainer);

        domConstruct.create("div", {
            class: "w3-text-red",
            innerHTML: '<i class="fa fa-exclamation-triangle">&nbsp;</i>'
        }, this.newDocumentErrorContainer);

        this.newDocumentErrorMessage = domConstruct.create("div", {}, this.newDocumentErrorContainer);
    }

    constructDocumentInfo(passId: string): void {

        let pass: IndividualData_PersonalDocumentInfo = this.allDocuments.filter(x => x.ID === passId)[0];

        console.debug("PASS", pass);

        if (pass) {

            this.UiModder.domClass.remove(this.selectedDocumentInfoContainer, "w3-hide");

            let date_from: Array<string> = pass.date_valid_from.split(".");
            let date_until: Array<string> = pass.date_valid_until.split(".");

            if (pass.is_active) {

                this.readonlyDocumentIsActive.value = this.translations["General_Yes"];
                this.UiModder.domClass.remove(this.btn_setAsInactive, "w3-hide w3-disabled");
            } else {

                this.readonlyDocumentIsActive.value = this.translations["General_No"];
                this.UiModder.domClass.add(this.btn_setAsInactive, "w3-hide w3-disabled");
            }

            this.readonlyDocumentNumber.value = pass.personal_doc_number;
            this.readonlyDocumentValidFrom.valueAsDate = new Date(`${date_from[2]}-${date_from[1]}-${date_from[0]}`);
            this.readonlyDocumentValidUntil.valueAsDate = new Date(`${date_until[2]}-${date_until[1]}-${date_until[0]}`);
            this.readonlyDocumentIssuedAuthority.value = pass.issued_authority_original;
        } else {

            this.UiModder.domClass.add(this.selectedDocumentInfoContainer, "w3-hide");
        }
    }

    serializeFormData(): void {

        this.formData.document_type = this.newDocumentType.getValue();
        this.formData.personal_doc_number = this.newDocumentNumber.getValue();
        this.formData.issued_country = this.newDocumentIssuedCountry.getValue();
        this.formData.issued_authority_original = this.newDocumentIssuedAuthority.getValue();
        this.formData.date_valid_from = this.newDocumentValidFrom.getValue();
        this.formData.date_valid_until = this.newDocumentValidUntil.getValue();
        this.formData.is_main_document = this.newDocumentIsMainDocument.getValue();

        this.checkSaveButtonDisable();

        console.debug("SERIALIZE DATA:", this.formData);
    }

    checkSaveButtonDisable(): void {

        if (this.isValid()) {

            this.saveNewDocumentBtn.setClasses(" ", "w3-disabled");
            this.showNewDocumentErrorMessage(false);
        } else {

            this.saveNewDocumentBtn.setClasses("w3-disabled", " ");
        }
    }

    isValid(): boolean {

        let b: boolean = true;

        if (!this.formData.document_type) {

            //this.UiModder.domClass.add(this.newDocumentType.containerNode, "w3-pale-red");
            b = false;
        } else {

            //this.UiModder.domClass.remove(this.newDocumentType.containerNode, "w3-pale-red");
        }
        if (!this.formData.personal_doc_number) {

            this.UiModder.domClass.add(this.newDocumentNumber.inputNode, "w3-pale-red");
            b = false;
        } else {

            this.UiModder.domClass.remove(this.newDocumentNumber.inputNode, "w3-pale-red");
        }
        if (!this.formData.issued_country) {

            //this.UiModder.domClass.add(this.newDocumentIssuedCountry.outerInput, "w3-pale-red");
            b = false;
        } else {

            //this.UiModder.domClass.remove(this.newDocumentIssuedCountry.outerInput, "w3-pale-red");
        }
        if (!this.formData.issued_authority_original) {

            this.UiModder.domClass.add(this.newDocumentIssuedAuthority.inputNode, "w3-pale-red");
            b = false;
        } else {

            this.UiModder.domClass.remove(this.newDocumentIssuedAuthority.inputNode, "w3-pale-red");
        }
        if (!this.formData.date_valid_from) {

            this.UiModder.domClass.add(this.newDocumentValidFrom.inputNode, "w3-pale-red");
            b = false;
        } else {

            this.UiModder.domClass.remove(this.newDocumentValidFrom.inputNode, "w3-pale-red");
        }
        if (!this.formData.date_valid_until) {

            this.UiModder.domClass.add(this.newDocumentValidUntil.inputNode, "w3-pale-red");
            b = false;
        } else {

            if (this.formData.date_valid_until <= new Date()) {

                this.UiModder.domClass.add(this.newDocumentValidUntil.inputNode, "w3-pale-red");
                b = false;
            } else {

                this.UiModder.domClass.remove(this.newDocumentValidUntil.inputNode, "w3-pale-red");
            }
        }

        if (this.formData.date_valid_from && this.formData.date_valid_until) {

            if (this.formData.date_valid_from > this.formData.date_valid_until) {

                this.UiModder.domClass.add(this.newDocumentValidFrom.inputNode, "w3-pale-red");
                this.UiModder.domClass.add(this.newDocumentValidUntil.inputNode, "w3-pale-red");
                b = false;
            }
        }

        return b;
    }

    _onChange_newDocumentData() {

        this.serializeFormData();
    }

    _onClick_saveBtn(evt: any): void {

        this.serializeFormData();

        if (this.isValid()) {

            let requestUrl = window.appRoot + "IndividualDataSheet/SaveFormData";
            this.StandbyStart();

            this.RequestManager.post(
                requestUrl,
                {
                    jsonData: JSON.stringify(this.formData),
                    sectionName: IndividualData_SectionName.PersonalDocumentsInfo
                },
                lang.hitch(this, this._onSaveFormDataResponse),
                lang.hitch(this, this._onSaveFormDataError),
                false // sync
            );
        } else {

            this.showNewDocumentErrorMessage(true, this.translations["IndividualDataSheet_ContactData_DataNotValid"]);
        }
    }

    _onSaveFormDataResponse(): void {

        this.StandbyStop();

        let dlg = new GenericDialog();

        dlg.destroyOnClose = true;
        this.UiModder.domStyle.set(dlg.modalDlgContentNode, "width", "600px");
        this.UiModder.domStyle.set(dlg.modalDlgContentNode, "margin-top", "100px");
        //this.UiModder.domClass.add(dlg.modalDlgContentNode, "w3-round");
        //this.UiModder.domStyle.set(dlg.textNode, "min-height", "150px");
        //this.UiModder.domClass.replace(dlg.headerBarNode, "mds-bg-orange", "secondaryBG");
        //this.UiModder.domClass.add(dlg.textNode, "w3-padding-64 w3-container w3-center");

        dlg.show(this.translations["FormDialog_Document_Save_Message"], this.translations["FormDialog_Save_Header"], null, "fas fa-info-circle", "ok");

        this.emit("DataForm_close");
    }

    _onClick_setAsInactiveBtn(): void {

        let dlg = new GenericDialog();

        dlg.show(this.translations["FormDialog_Document_setAsInaktive"], this.translations["FormLabel_IsAktive"], null, "fas fa-question", "yesno", lang.hitch(this, this.setDocumentAsInactive));
        dlg.destroyOnClose = true;
        this.UiModder.domStyle.set(dlg.modalDlgContentNode, "width", "600px");
        this.UiModder.domStyle.set(dlg.modalDlgContentNode, "margin-top", "100px");
    }

    setDocumentAsInactive(dlgResult: any): void {

        if (dlgResult === 2) {

            let requestUrl = window.appRoot + "IndividualDataSheet/SetPassportAsInactive";
            this.StandbyStart();

            this.RequestManager.post(
                requestUrl,
                {
                    passId: this.documentSelect.getValue()
                },
                lang.hitch(this, this._onSetDocumentAsInactiveResponse),
                lang.hitch(this, this._onSetDocumentAsInactiveError),
                false // sync
            );
        }        
    }

    _onSetDocumentAsInactiveResponse(): void {

        this.refreshData();
    }

    refreshData(): void {

        let requestUrl = window.appRoot + "IndividualDataSheet/GetSectionDataByName";

        this.RequestManager.post(
            requestUrl,
            {
                sectionName: IndividualData_SectionName.PersonalDocumentsInfo
            },
            lang.hitch(this, this._onRefreshDataResponse),
            lang.hitch(this, this._onRefreshDataError),
            false // sync
        );
    }

    _onRefreshDataResponse(data: Array<IndividualData_PersonalDocumentInfo>): void {

        this.StandbyStop();

        this.loadFormData(data);
    }

    _onChange_SelectedDocument(): void {

        this.constructDocumentInfo(this.documentSelect.getValue());
    }

    _onChangeDocumentDataInput(): void {

        
    }

    _onRefreshDataError(err): void {

        this.StandbyStop();
        alert(err.Message);
    }

    _onSetDocumentAsInactiveError(err): void {

        this.StandbyStop();
        alert(err.Message);
    }

    _onSaveFormDataError(err): void {

        this.StandbyStop();

        this.showNewDocumentErrorMessage(true, err.Message);
    }

    showNewDocumentErrorMessage(bool: boolean, msg?: string) {

        if (bool) {

            this.UiModder.domClass.remove(this.newDocumentErrorContainer, "w3-hide");
            msg ? this.newDocumentErrorMessage.innerHTML = msg : this.newDocumentErrorMessage.innerHTML = "...error occured";
        } else {

            this.UiModder.domClass.add(this.newDocumentErrorContainer, "w3-hide");
            this.newDocumentErrorMessage.innerHTML = "";
        }
    }

    postCreate(): void {
        super.postCreate.apply(this, arguments as any);
    }

    startup(): void {
        super.startup.apply(this, arguments as any);
    }
}

mdsLazyProto(PersonalDocumentInfoDataForm.prototype, {
  newDocumentNumber: () => (new Edit()),
  newDocumentValidFrom: () => (new DateInput()),
  newDocumentValidUntil: () => (new DateInput()),
  newDocumentIssuedAuthority: () => (new Edit()),
  newDocumentIssuedCountry: () => (new SearchSelect()),
  newDocumentIsMainDocument: () => (new CheckBox()),
  saveNewDocumentBtn: () => (new Button()),
});
export default mdsWidget(PersonalDocumentInfoDataForm);